import { initialState } from '@/models/options';

/**
 * Freelancer projects became companies. Carry the persisted freelancer filter
 * selection and the two table-view column keys over to their new names, so a
 * returning user keeps their filter and column choices instead of silently
 * hydrating an empty filter and a hidden column.
 */
const v40 = (state: any) => {
  const { projects, ...freelancerFilters } =
    state.filters?.freelancerFilters ?? {};

  const renameColumn = (table: any) => {
    const { Project, ...kept } = table ?? {};

    return {
      ...kept,
      ...(Project !== undefined && { Company: Project }),
    };
  };

  return {
    ...state,
    filters: {
      ...state.filters,
      freelancerFilters: {
        ...freelancerFilters,
        companies: projects ?? [],
      },
    },
    options: {
      ...state.options,
      tableViews: {
        ...state.options?.tableViews,
        freelancersTable: {
          ...initialState.tableViews.freelancersTable,
          ...renameColumn(state.options?.tableViews?.freelancersTable),
        },
        invoicesTable: {
          ...initialState.tableViews.invoicesTable,
          ...renameColumn(state.options?.tableViews?.invoicesTable),
        },
      },
    },
  };
};

export default v40;
